<template>
  <div
    :item-id="itemId"
    :request-status="requestStatus"
    @reload="$emit('reload', $event)"
  >
    <div
      ref="chartdiv"
      class="gauge-chart"
    />
  </div>
</template>

<script>

import * as am4core from '@amcharts/amcharts4/core';
import cardsModel from '@/mixins/cards-model';
import gaugeModel from '@/mixins/gauge-model';

export default {
  name: 'PercentGauge',
  mixins: [
    cardsModel,
    gaugeModel,
  ],
  props: {
    score: {
      type: Object,
      default: () => {
        return { value: 0 };
      },
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    requestStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chartMin: 0,
      chartMax: 100,
      gradingData: [
        {
          title: '',
          color: '#ee1f25',
          lowScore: -1,
          highScore: 20,
        },
        {
          title: '',
          color: '#ee5757',
          lowScore: 20,
          highScore: 40,
        },
        {
          title: '',
          color: '#fdae19',
          lowScore: 40,
          highScore: 60,
        },
        {
          title: '',
          color: '#b0d136',
          lowScore: 60,
          highScore: 80,
        },
        {
          title: '',
          color: '#0f9747',
          lowScore: 80,
          highScore: 100,
        },
      ],
      matchingGrade: [],
      axis2: '',
    };
  },

  methods: {
    setLabel() {
      const label = this.chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      label.fontSize = '4em';
      label.x = am4core.percent(50);
      label.paddingBottom = -5;
      label.horizontalCenter = 'middle';
      label.verticalCenter = 'bottom';
      label.text = `${this.score.value.toFixed()}%`;
      label.fill = am4core.color(this.matchingGrade.color);
    },
  },
};
</script>

<style scoped>
  .gauge-chart {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.2rem;
  }
</style>
